import { type LayoutV2Info } from '@blaze-shared/api-contracts-domain';
import { type NavMenu } from '@blaze-shared/elements-domain';
import { type Connection } from '@blaze-shared/workflow-domain';

import { type CanvasElement, type CanvasNamespaceId } from '../canvas-element/canvas-element';

export interface LayoutData extends LayoutV2Info {
  actionLayer: {
    connections: Connection[];
  };
  uiLayer: {
    content: CanvasElement[];
    properties?: LayoutUiLayerProperties;
  };
}

export interface LayoutSyncPayload {
  connections: Connection[];
  elements: CanvasElement[];
  layoutEntities: Record<CanvasNamespaceId, LayoutData>;
  offSyncLayouts: Record<CanvasNamespaceId, boolean>;
  layoutIds: CanvasNamespaceId[];
  navMenuItems: NavMenu.LegacySharedItem[];
}

export interface LayoutUiLayerProperties {
  type: 'NavMenuItems';
}

export const NAV_MENU_ITEMS_LAYOUT_TYPE: LayoutUiLayerProperties['type'] = 'NavMenuItems';

export function isNavMenuItemsLayout(layout?: Pick<LayoutData, 'uiLayer'> | null): boolean {
  return layout?.uiLayer?.properties?.type === NAV_MENU_ITEMS_LAYOUT_TYPE;
}
